import { cn } from '@/util/cn';
import React, { useEffect, useRef, useState } from 'react';
import { AdUnit, AdUnitClasses } from '@/tracking/ads/components/AdUnit';
import { useAdUnitContext } from '@/tracking/ads/components/AdUnitContext';
import { GPTAds } from '@/tracking/ads/GPTAds';
import { AdPositions } from '@/tracking/ads/types';
import { isProductionServer } from '@/ots-constants';
import { SizeMonitor } from '@/components/size/SizeMonitor';

// Debug indicator: a 10×10 dot rendered next to each ad slot that shows
// blue when the ad is requested and red when the slot is ignored.
// Invisible + non-interactive in production.
const adMonitorBaseClass = 'absolute h-2.5 w-2.5 rounded-full z-[100] -translate-y-1.5';

export const RegularAd = ({ wrapperClassName, className, isFirst }: { wrapperClassName?: string, className?: string, isFirst?: boolean }) => {
  const [active, setActive] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  const { registerCandidate, unRegisterCandidate } = useAdUnitContext();

  useEffect(() => {
    const id = registerCandidate(ref, setActive);
    return () => unRegisterCandidate(id);
  }, []);

  const adUnit = isFirst ? AdPositions.RegularFirstOnPage : AdPositions.Regular;

  return (
    <div
      data-adunit={adUnit}
      className={cn(wrapperClassName, !active && '!m-0 !p-0 h-0')}
    >
      <SizeMonitor>
        <div
          ref={ref}
          className={cn(
            adMonitorBaseClass,
            active ? 'bg-[#0B7595] z-[101] translate-x-0.5' : 'bg-red-500 -translate-x-0.5',
            isProductionServer && 'opacity-0 pointer-events-none',
          )}
          title={active ? 'Debug: Advertisement is requested here' : 'Debug: Advertisement is ignored here'}
        />
        {active && (
          <AdUnit
            generator={GPTAds[adUnit]}
            className={cn(className, AdUnitClasses.infinite)}
          />
        )}
      </SizeMonitor>
    </div>
  );
};
